"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservationListNotification = void 0;
const react_1 = __importStar(require("react"));
const useForm_1 = require("../../../../hooks/useForm");
const classFunctions_1 = require("../../../../utils/classFunctions");
const Textarea_1 = require("../../../Form/Field/Textarea");
const className = 'reservation-list-notification';
const ReservationListNotification = (props) => {
    const { formConfig, validator, onSubmit, onChangeFormData, callValidation, } = props;
    const { fields, onSubmit: formSubmit, validate: formValidate, } = (0, useForm_1.useLegacyForm)(formConfig, onSubmit, validator, onChangeFormData);
    const handleOnSubmit = (0, react_1.useCallback)((e) => {
        e.preventDefault();
        formSubmit();
    }, [formSubmit]);
    (0, react_1.useEffect)(() => {
        if (callValidation) {
            callValidation.current = () => {
                return formValidate();
            };
        }
    }, [callValidation, formValidate]);
    const classNames = (0, classFunctions_1.getClassNames)(className);
    return (react_1.default.createElement("form", { className: classNames, onSubmit: handleOnSubmit },
        react_1.default.createElement("div", { className: `${className}__content` },
            react_1.default.createElement(Textarea_1.FormFieldTextarea, { error: fields.content.error, value: fields.content.value, onChange: fields.content.onEvent }))));
};
exports.ReservationListNotification = ReservationListNotification;
//# sourceMappingURL=index.js.map